import type { StateStore } from "../app/state/StateStore";

import { BaseBlock } from "./BaseBlock";

/**
 * Блок с названием дополнительного материала.
 */
export class NoticeTitleBlock extends BaseBlock {

    constructor(
        private readonly store: StateStore
    ) {
        super();
    }

    public override mount(): void {

        this.root =
            this.render();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    private render(): HTMLElement {

        const wrapper =
            document.createElement("div");

        const state =
            this.store.getState();

console.log(
    "NOTICE STATE",
    state.primaryScreen
);

        if (state.primaryScreen.type !== "notice") {
            return wrapper;
        }

        const data =
            state.primaryScreen.notice?.[0];

console.log(
    "NOTICE DATA",
    data
);

        if (!data?.title) {
            return wrapper;
        }

        wrapper.className =
            "task explanation-task";

        wrapper.innerHTML = `
            <p>
                Читайте / Дивіться важливе лексичне доповнення до цього кроку:
            </p>

            <b>${data.title}</b>
        `;

        return wrapper;

    }

}